import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaTable from 'Components/UI/Meta/MetaTable';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import fr from 'facet-rest';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import LoadingIndicator from 'Components/UI/LoadingIndicator';
import AumApexAccountLayout from 'Views/Page/Content/Templates/AumHouseholdViewTemplate/MainPanel/AumApexAccountLayout';
import Card from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Card';
import { metaOverrideSet } from './metaOverrideSet';

const styles = () => ({
  root: {},
  fields: {},
});

const AumApexDetails = ({
  resource,
}) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    async function fetchData() {
      if (resource) {
        const accountCollection = await resource.relationship(fr.relationships.aumApexAccountDetails.name).link('related').get();
        setData(accountCollection);
      }
    }

    fetchData().finally(() => {
      setLoading(false);
    });
  }, []);
  if (loading) {
    return <LoadingIndicator />;
  }
  if (!data) {
    return null;
  }
  return (

    <React.Fragment>

      {data.resources().list().map((res) => {
        return (
          <Card>
            <MetaFormInline
              resource={res}
              layout={AumApexAccountLayout}
              readonly
            />
          </Card>
        );
      })
        }

    </React.Fragment>
  );
};
AumApexDetails.propTypes = {
  resource: PropTypes.object.isRequired,
};

const MainPanel = ({
  className,
  classes,
}) => {
  const { pageContentCollection } = usePageContentContext();
  function handleExpanded(resource) {
    return (
      <AumApexDetails
        resource={resource}
      />
    );
  }
  return (
    <MetaTable
      onExpanded={handleExpanded}
      className={classNames(className, classes.root)}
      classes={{ cell: classes.root }}
      collection={pageContentCollection}
      RowProps={{
        metaOverrideSet,
      }}

    />
  );
};

MainPanel.defaultProps = {
  className: '',
};

MainPanel.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MainPanel);
